<ng-select [items]="industry$ | async" bindLabel="industryName"
    [placeholder]="placeholder" [multiple]="allowMultiple" [hideSelected]="true" [readonly]="readonly" [addTag]="allowAdding"
    [trackByFn]="trackByFnIndustry" [loading]="industryLoading" [typeahead]="industryInput$" [(ngModel)]="selectedIndustry"
    (change)="onIndustrySelectChange($event)" (clear)="onIndustrySelectRemove($event)">
    <ng-template ng-loadingspinner-tmp>
        <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </ng-template>
</ng-select>